const { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar } = require("recharts")

const Chart = ({ data, dataKey, angle = 0, XAxisShow = false, XAxisHeight, height = 400, textAnchor, bar = [{ key: "Available", fill: "#8884d8" }, { key: "NotAvailable", fill: "#FF2255" }] }) => {




    return <ResponsiveContainer width="100%" height={height}>
        <BarChart
            width={500}
            height={300}
            data={data}
            margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 5,
            }}
            barSize={data?.length < 2 ? 20 : 10}
        >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis hide={XAxisShow} dataKey={dataKey} angle={angle} textAnchor={textAnchor} height={XAxisHeight} />
            <YAxis />
            <Tooltip />
            <Legend />
            {
                bar.map(_state => {
                    return <Bar dataKey={_state.key} stackId="a" fill={_state.fill} />
                })
            }
        </BarChart>
    </ResponsiveContainer>
}


export default Chart